const getValidDate = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? null
    : date;
};

export const getRepeatEndDate = (schedule, event, task) => {
  const parentSchedule = schedule.parentSchedule || schedule;
  const scheduleIds = [schedule.id, schedule.publicId, parentSchedule.id, parentSchedule.publicId]
    .filter((id) => id !== undefined && id !== null)
    .map(String);
  const taskBelongsToSchedule = task && scheduleIds.includes(String(task.scheduleId));
  const taskStartDate = taskBelongsToSchedule && getValidDate(task.startDate);
  const taskOccurrenceDate = taskStartDate
    && getValidDate(taskStartDate.getTime() + Number(schedule.advanceNotice || 0));
  const occurrenceDate = taskOccurrenceDate
    || (event && getValidDate(event.originalStart))
    || (event && getValidDate(event.start))
    || (event && getValidDate(event.startDate))
    || (schedule.parentSchedule && getValidDate(schedule.startDate))
    || getValidDate(parentSchedule.nextOccurrenceDate)
    || getValidDate(parentSchedule.startDate);
  const existingEndDate = getValidDate(parentSchedule.endDate);

  // Ending a repeat must never extend a series that has already ended.
  if (occurrenceDate && existingEndDate && existingEndDate < occurrenceDate) {
    return existingEndDate;
  }
  return occurrenceDate;
};
